var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobileOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.332 1.16406H4.9987C4.55667 1.16406 4.13275 1.33966 3.82019 1.65222C3.50763 1.96478 3.33203 2.3887 3.33203 2.83073V14.1641C3.33203 14.6061 3.50763 15.03 3.82019 15.3426C4.13275 15.6551 4.55667 15.8307 4.9987 15.8307H10.332C10.7741 15.8307 11.198 15.6551 11.5105 15.3426C11.8231 15.03 11.9987 14.6061 11.9987 14.1641V2.83073C11.9987 2.3887 11.8231 1.96478 11.5105 1.65222C11.198 1.33966 10.7741 1.16406 10.332 1.16406ZM7.66536 15.1641C7.11203 15.1641 6.66536 14.7174 6.66536 14.1641C6.66536 13.6107 7.11203 13.1641 7.66536 13.1641C8.2187 13.1641 8.66536 13.6107 8.66536 14.1641C8.66536 14.7174 8.2187 15.1641 7.66536 15.1641ZM10.6654 12.4974H4.66536V3.16406H10.6654V12.4974Z",
    fill: "url(#paint0_linear_10210_1843)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10210_1843",
    x1: 3.33203,
    y1: 1.16406,
    x2: 14.3555,
    y2: 3.2251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F4FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileOutline);
export default __webpack_public_path__ + "static/media/mobile-outline.80d3654a520a6deae12e3a9df1ec1f3c.svg";
export { ForwardRef as ReactComponent };